import script from "./emergenzaCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./emergenzaCreate.vue?vue&type=script&setup=true&lang=ts"

import "./emergenzaCreate.vue?vue&type=style&index=0&id=338e0148&lang=css"

const __exports__ = script;

export default __exports__